import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import SplashScreen from './components/SplashScreen';
import TopBar from './components/layout/TopBar';
import Header from './components/layout/Header';
import HeroSlider from './components/sections/HeroSlider';
import StatsSection from './components/sections/StatsSection';
import MissionSection from './components/sections/MissionSection';
import VideoSection from './components/sections/VideoSection';
import ProgramsSection from './components/sections/ProgramsSection';
import EventsSection from './components/sections/EventsSection';
import NewsSection from './components/sections/NewsSection';
import NewsletterSection from './components/sections/NewsletterSection';
import Footer from './components/layout/Footer';
import Register from './pages/Register';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ConferenceRegistration from './pages/ConferenceRegistration';
import AdminDashboard from './pages/AdminDashboard';
import Donate from './pages/Donate';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyInvitation from './pages/VerifyInvitation';
import Events from './pages/Events';
import PaymentConfirmation from './pages/PaymentConfirmation';
import DonationConfirmation from './pages/DonationConfirmation';
import StaffCheckin from './pages/StaffCheckin';
import PartnerDashboard from './pages/PartnerDashboard';
import SessionExpiredModal from './components/SessionExpiredModal';
import ImpersonationBanner from './components/ImpersonationBanner';
import './App.css';

const HomePage = ({ showSplash, onSplashComplete }) => {
  return (
    <>
      {showSplash && <SplashScreen onComplete={onSplashComplete} />}
      <div className={`min-h-screen bg-white transition-opacity duration-500 ${showSplash ? 'opacity-0' : 'opacity-100'}`}>
        <TopBar />
        <Header />
        <main>
          <HeroSlider />
          <StatsSection />
          <MissionSection />
          <VideoSection />
          <ProgramsSection />
          <EventsSection />
          <NewsSection />
          <NewsletterSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

function App() {
  const [showSplash, setShowSplash] = useState(true);

  const handleSplashComplete = () => {
    setShowSplash(false);
  };

  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <ImpersonationBanner />
          <Routes>
            <Route path="/" element={<HomePage showSplash={showSplash} onSplashComplete={handleSplashComplete} />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/conference-registration" element={<ConferenceRegistration />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-invitation" element={<VerifyInvitation />} />
            <Route path="/events" element={<Events />} />
            <Route path="/payment-confirmation" element={<PaymentConfirmation />} />
            <Route path="/donation-confirmation" element={<DonationConfirmation />} />
            <Route path="/staff-checkin" element={<StaffCheckin />} />
            <Route path="/partner" element={<PartnerDashboard />} />
          </Routes>
          <SessionExpiredModal />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
